import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RoomEntity } from '@core/entities';
import { DefaultImageDirective } from '@shared/directives';
import { WeekdayPipe } from '@shared/pipes';
import { TippyModule } from '@ngneat/helipopper';
import { BadgeComponent, IconComponent } from '@shared/components/ui';
import { DialogService } from '@ngneat/dialog';
import { CourseRoomComponent } from '@shared/components';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';
import { isMobileView } from '@core/utils';
import { PermissionService } from '@auth';

@Component({
  selector: 'app-room-card',
  imports: [CommonModule, IconComponent, TranslateModule, DefaultImageDirective, WeekdayPipe, TippyModule, BadgeComponent],
  templateUrl: './room-card.component.html',
  styleUrls: ['./room-card.component.scss'],
})
export class RoomCardComponent {
  @Input() isMobileView = false;
  @Input() room: RoomEntity;

  @Output() deleteRoom = new EventEmitter<RoomEntity>();
  @Output() editRoom = new EventEmitter<RoomEntity>();

  private readonly _dialogService: DialogService;
  private readonly _bottomSheetService: NgxBottomSheetService;
  private readonly _permissionService: PermissionService = inject(PermissionService);

  constructor() {
    if (isMobileView()) {
      this._bottomSheetService = inject(NgxBottomSheetService);
    } else {
      this._dialogService = inject(DialogService);
    }
  }

  get isUserAdmin(): boolean {
    return this._permissionService.isAdmin() || false;
  }

  openRoomDetails() {
    if (!isMobileView()) {
      this._dialogService.open(CourseRoomComponent, {
        size: 'md',
        closeButton: false,
        windowClass: 'dialog-overflow-y-auto',
        data: {
          room: this.room,
        },
      });
    } else {
      this._bottomSheetService.open(CourseRoomComponent, {
        height: '95%',
        showCloseButton: false,
        data: {
          room: this.room,
        },
      });
    }
  }
}
